module.exports = __webpack_public_path__ + "img/PDF.24cea0d1.svg";